import React from "react";
import SlideOnScroll from "../utils/animations/slideOnScroll";
import { directions } from '../utils/animations/animationConstants';
export default function TechnologySliderNew(props) {
  const { data, platforms } = props;
  const triggers = [[0.90, 0.85], [0.87, 0.82], [0.84, 0.79], [0.81, 0.76], [0.79, 0.73]];
  return (
    <div className="technology-list-section section-gap">
      <div className="container">
        <div className="section-title">
          <p className="theme-color-title">Platforms</p>
          <h4>Our AI/ML and Analytics technology stack</h4>
        </div>
        <div className="d-flex flex-wrap">
          <div className="technology-block">
            <div className="row d-flex flex-wrap align-v-center">
              <div className="col technology-title-bar">
                <h6>AI + ML</h6>
              </div>
              <div className="col technology-list-bar">
                <ul className="technology-list">
                  {data.ai.map((item, i) => {
                    return (
                      <li key={i}>
                        <div>
                          <i>{item.icon}</i><p>{item.title}</p>
                        </div>
                      </li>);
                  })}
                </ul>
              </div>
            </div>
          </div>

          <div className="technology-block">
            <div className="row d-flex flex-wrap align-v-center">
              <div className="col technology-title-bar">
                <h6>Data Visualization</h6>
              </div>
              <div className="col technology-list-bar">
                <ul className="technology-list">
                  {data.visualization.map((item, i) => {
                    return (
                      <li key={i}>
                        <div>
                          <i>{item.icon}</i><p>{item.title}</p>
                        </div>
                      </li>);
                  })}
                </ul>
              </div>
            </div>
          </div>

          <div className="technology-block">
            <div className="row d-flex flex-wrap align-v-center">
              <div className="col technology-title-bar">
                <h6>Data Analytics</h6>
              </div>
              <div className="col technology-list-bar">
                <ul className="technology-list">
                  {data.analytics.map((item, i) => {
                    return (
                      <li key={i} className={item.title}>
                        <div>
                          <i>{item.icon}</i><p>{item.title}</p>
                        </div>
                      </li>);
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div className="platform">
        <div className="container">
          <div className="platform-inner">
            <div className="row d-flex flex-wrap align-v-center">

              <div className="col technology-title-bar">
                <h6>PLATFORMS</h6>
              </div>
              <div className="col technology-list-bar d-flex flex-wrap align-v-center justify-space">
                {platforms.map((platform, i) => {
                  return <SlideOnScroll classes="grid-item" triggerPoints={triggers[i]} direction={directions.BTT} key={i}>
                    <div className="d-flex align-v-center">
                      <div className="grid-icon">
                        <i>{platform.icon}</i>
                      </div>
                      <div className="grid-item-content">
                        <h3>{platform.title}</h3>
                      </div>
                    </div>
                  </SlideOnScroll>;
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
